/* computer menu: Home & Kitchen dropdown - click/tap to toggle, closes on outside click, mouse leave, Escape or scroll */
(function () {
  'use strict';
  if (window.__afhDdLoaded) return;
  window.__afhDdLoaded = true;

  function closeAll(except) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-afh-dd].is-open'), function (d) {
      if (d === except) return;
      d.classList.remove('is-open');
      var b = d.querySelector('[data-afh-dd-toggle]');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-afh-dd-toggle]');
    if (b) {
      e.preventDefault();
      var d = b.closest('[data-afh-dd]');
      var open = !d.classList.contains('is-open');
      closeAll(d);
      d.classList.toggle('is-open', open);
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    if (!(e.target.closest && e.target.closest('[data-afh-dd]'))) closeAll();
  });
  document.addEventListener('mouseout', function (e) {
    var d = e.target.closest && e.target.closest('[data-afh-dd].is-open');
    if (!d || (e.relatedTarget && d.contains(e.relatedTarget))) return;
    closeAll();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  window.addEventListener('scroll', function () { closeAll(); }, { passive: true });
})();
